/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react';
import PropTypes from 'prop-types';
import { useSendEvent } from '@domain-group/fe-co-allhomes-analytics';
import { ChevronRightIcon } from '@domain-group/fe-co-icon';
import { OptionMap } from './option-map';
import * as styles from './option.style';
import { jsx as ___EmotionJSX } from "@emotion/core";
var renderIcon = Icon => Icon ? ___EmotionJSX(Icon, {
  css: styles.icon,
  size: "regular"
}) : null;
var Option = props => {
  var _useSendEvent = useSendEvent(),
    sendEvent = _useSendEvent.sendEvent;
  var handleOnClick = () => {
    sendEvent('browse-option-click', {
      optionName: props.icon,
      position: props.position
    });
    props.onClick();
  };
  return ___EmotionJSX("h3", {
    css: styles.option
  }, renderIcon(OptionMap[props.icon].icon), ___EmotionJSX("a", {
    css: styles.link,
    href: props.type ? '#' : props.href,
    onClick: handleOnClick
  }, props.label), ___EmotionJSX(ChevronRightIcon, {
    css: styles.arrow,
    size: "small"
  }));
};
Option.propTypes = {
  icon: PropTypes.string,
  label: PropTypes.string.isRequired,
  href: PropTypes.string,
  onClick: PropTypes.func,
  type: PropTypes.string,
  position: PropTypes.number.isRequired
};
Option.defaultProps = {
  icon: undefined,
  href: undefined,
  onClick: () => {},
  type: undefined
};
export default Option;